export enum ViewFilterAlignment {
  Left = 0,
  Right = 10,
}
